import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { fetchPermissions } from "#modules/permissions/infra/fetchPermissions.api";
import { PermissionDto } from "#modules/permissions/infra/Permission.dto";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { QueryOptions } from "#types/QueryOptions";

export const permissionsQuery = (): QueryOptions<PermissionDto[]> => ({
  queryKey: queryKeys.permissions.all,
  queryFn: () => fetchPermissions(),
  staleTime: STALE_TIME_L,
});
